/**
 * Místo ukotvení markeru nad centrem feature.
 */
enum MarkerAnchor {
    /**
     * Marker je ukotven za svoji spodní středovou část.
     */
    BOTTOM = 'bottom',

    /**
     * Marker je ukotven za svůj střed.
     */
    CENTER = 'center',
}

export default MarkerAnchor;
